import React, { useMemo } from 'react';
import { BrowserRouter, Route, Routes,Navigate ,useParams} from 'react-router-dom';
// Core Pages
import Home from '../components/Home/Home';
import Contact from '../components/Contact/Contact';
import InfoContact from '../components/InfoContact/InfoContact';
import Blog from '../components/Blog/Blog';
import BlogDetail from '../components/BlogDetail/BlogDetail';
import ResetPassword from '../components/ResetPassword/ResetPassword';
import Userdashboard from '../components/userdashboard/Userdashboard';
import Profile from '../components/Profile/Profile';
import DashboardMobile from '../components/DashboardMobile/DashboardMobile';
import Test from '../components/Test/Test';
import Dilemma from '../components/Dilemma/Dilemma';
import FreeTest from '../components/Test/FreeTest';
import TestShow from '../components/TestShow/TestShow';
import PricePlan from '../components/PricePlan/PricePlan';
import SubShow from '../components/TestShow/SubShow';
import TestQuestions from '../components/TestQuestions/TestQuestions';
import Questions32 from '../components/Questions32/Questions32';
import PastResults from '../components/PastResults/PastResults';
import ResultAll from '../components/ResultAll/ResultAll';
import DarkResult from '../components/DarkResult/DarkResult';
import AdminTest from '../components/DarkResult/AdminTest';
import EmailResults from '../components/EmailResults/EmailResults';
import DarkEmailResults from '../components/DarkEmailResults/DarkEmailResults';

import Achievements from '../components/Achievements/Achievements';
import Notifications from '../components/Notifications/Notifications';

import UserSubcription from '../components/UserSubcription/UserSubcription';

import Classifications from '../components/Classifications/Classifications';


import ArchetypeDetailPage from "../components/ArchetypeDetailPage/ArchetypeDetailPage";
import DarkPersonality from '../components/DarkPersonality/DarkPersonality';

import FinalPage from '../components/FinalPage/FinalPage';

import DeepDrive from '../components/DeepDrive/DeepDrive';

import AsmDetail from '../components/AsmDetail/AsmDetail';
import SideModalOne from '../components/SideModalOne/SideModalOne';
import SideModalTwo from '../components/SideModalTwo/SideModalTwo';
import SideModalThree from '../components/SideModalThree/SideModalThree';
import SideModalFour from '../components/SideModalFour/SideModalFour';

import ProtectedRoute from '../components/ProtectedRoute';
import TestProtectedRoute from '../components/TestProtectedRoute';
import DeepProtectedRoute from '../components/DeepProtectedRoute';

import ScheduleMeeting from '../components/ScheduleMeeting/ScheduleMeeting';
import AdminPage from '../components/FinalPage/AdminPage';
import AdminResult from '../components/ResultAll/AdminResult';
import About from '../components/About/About';
import Terms from '../components/Terms/Terms';
import Ebook from '../components/Ebook/Ebook';
import SpecialQuizes from '../components/SpecialQuizes/SpecialQuizes';
import NewDashboard from '../components/NewDashboard/NewDashboard';
import HomeSocialMedia from '../components/HomeSocialMedia/HomeSocialMedia';
import PastAttempts from '../components/Questions32/PastAttempts';
import ViewAttempt from '../components/Questions32/ViewAttempt';
import ZoomMetting from '../components/Questions32/ZoomMetting';
import ArchetypeTimeline from '../components/NewDashboard/ArchetypeTimeline';
import CalculateArchetype from '../components/CalculateArchetype/CalculateArchetype';
import DoughnutLinearChart from '../components/DoughnutLinearChart/DoughnutLinearChart';
import Trail from '../components/Trail/Trail';
import DilemaResultBeforePayment from '../components/DilemaResultBeforePayment/DilemaResultBeforePayment';
import DilemaQuizResult from '../components/DilemaQuizResult/DilemaQuizResult';
import DilemaReport from '../components/DilemaReport/DilemaReport';
import DilemmaNoTest from '../components/Dilemma/DilemmaNoTest';
import DilemmaPasts from '../components/DilemmaPasts/DilemmaPasts';
import TemplatePage from '../components/TemplatePage/TemplatePage';
import NoPage from '../components/NoPage/NoPage';
import AdaptorComponent from '../components/AdaptorComponent/AdaptorComponent';
import AdaptorSinglePage from '../components/AdaptorSinglePage/AdaptorSinglePage';
import EbookList from '../components/EbookList/EbookList';
import QuizHub from '../components/QuizHub/QuizHub';
import TestWrapper from'../components/TestWrapper/TestWrapper';
import Hub from '../components/Hub/Hub';

import HubListingPage from "../components/HubTemplates/HubListingPage";
import HubTopicDetail from "../components/HubTemplates/HubTopicDetail";
import HubSubDetail from "../components/HubTemplates/HubSubDetail";
import HubFinal from "../components/HubTemplates/HubFinal";

// import EbookNew from '../components/Ebook/EbookNew';

function AllRoutes({HubTemplateSlugs,quizLinks,randomTest, Notification,menuLink,isLoading, onsignup,token, free_test_slug, onNavHide, onLoginChange, globaltest, userdetail, ProfileChange, hasSubscription }) {

    // const componentMap = {
    //   asmandnacho: (props) => <AsmDetail {...props} />,
    //   "64Archetypes": (props) => (
    //     <Classifications {...props} />
    //   ),
    //   "top-tier-subscriptions": (props) => (
    //     <TestShow {...props} />
    //   ),
    //   blog: (props) => <Blog {...props} />,
    //   contact: (props) => <Contact {...props} />,
    // };

      const componentMap = useMemo(() => ({

          asmandnacho: AsmDetail,
          "64Archetypes": Classifications,
          "top-tier-subscriptions": TestShow,
          blog: Blog,

          contact: Contact,
      }), []); 

      const asmPage = menuLink?.find(
          item => item.ref_link === "asmandnacho"
      );

      const asmNewUrl = asmPage?.menu_link;

  return (
    <div>
      <BrowserRouter>
        <Routes>

          <Route
              path="/asmandnacho"
              element={
                  asmNewUrl ? (
                      <Navigate
                          to={`/${asmNewUrl}`}
                          replace
                      />
                  ) : (
                      <AsmDetail
                          token={token}
                          userdetail={userdetail}
                          free_test_slug={free_test_slug}
                          onLoginChange={onLoginChange}
                      />
                  )
              }
          />

          <Route
              path="/ATSM&NACHO"
              element={
                  asmNewUrl ? (
                      <Navigate
                          to={`/${asmNewUrl}`}
                          replace
                      />
                  ) : (
                      <AsmDetail
                          token={token}
                          userdetail={userdetail}
                          free_test_slug={free_test_slug}
                          onLoginChange={onLoginChange}
                      />
                  )
              }
          />

          <Route
              path="/ATSM-NACHO"
              element={
                  asmNewUrl ? (
                      <Navigate
                          to={`/${asmNewUrl}`}
                          replace
                      />
                  ) : (
                      <AsmDetail
                          token={token}
                          userdetail={userdetail}
                          free_test_slug={free_test_slug}
                          onLoginChange={onLoginChange}
                      />
                  )
              }
          />

          <Route path="/" element={<Home free_test_slug={free_test_slug}  />} />

             {/* {menuLink?.map((item) => {
                if (!item.ref_link) return null;

                const Component = componentMap[item.ref_link];
                if (!Component) return null;

                 const routePath =
                                  item.ref_link === "64Archetypes-detail"
                                      ? `/${item.menu_link}/:slug`
                                      : `/${item.menu_link}`;

                return (
                  <Route
                    key={item.id}
                    path={routePath}
                    element={
                      <Component
                        token={token}
                        userdetail={userdetail}
                        free_test_slug={free_test_slug}
                        onLoginChange={onLoginChange}
                      />
                    }
                  />
                );
              })} */}

              {menuLink?.map((item) => {

                if (!item.ref_link) return null;

                const Component = componentMap[item.ref_link];

                if (!Component) return null;

                  return (
                      <React.Fragment key={item.id}>

                          <Route
                              path={`/${item.menu_link}`}
                              element={
                                  <Component
                                      token={token}
                                      userdetail={userdetail}
                                      free_test_slug={free_test_slug}
                                      onLoginChange={onLoginChange}
                                      onsignup={onsignup}
                                  />
                              }
                          />

                          {item.ref_link === "64Archetypes" && (
                              <Route
                                  path={`/${item.menu_link}/:slug`}
                                  element={
                                      <ArchetypeDetailPage
                                          token={token}
                                          userdetail={userdetail}
                                          free_test_slug={free_test_slug}
                                          onLoginChange={onLoginChange}
                                          onsignup={onsignup}
                                      />
                                  }
                              />
                          )}

                      </React.Fragment>
                    );
          
                })}

                {/* <Route
                  path="arche/:slug/"
                  element={<SpecialQuizes onLoginChange={onLoginChange} userdetail={userdetail} />}
                /> */}

              {quizLinks?.map((link) => (

                  <Route key={link} path={`/${link}`}
                    
                    element={ <SpecialQuizes
                                onLoginChange={onLoginChange}
                                userdetail={userdetail}
                                slug={link}
                        />
                    }
                  />
              ))}

            {HubTemplateSlugs?.length > 0 &&

                HubTemplateSlugs.map((link) => {
                  let element = null;

                  if (link.model === "HubListingPage") {
                    element = (
                      <HubListingPage
                        slug={link.slug}
                        token={token}
                        onsignup={onsignup}
                        onLoginChange={onLoginChange}
                        userdetail={userdetail}
                      />
                    );
                  } else if (link.model === "HubTopicDetail") {
                    element = (
                      <HubTopicDetail
                        slug={link.slug}
                        token={token}
                        onsignup={onsignup}
                        onLoginChange={onLoginChange}
                        userdetail={userdetail}
                      />
                    );
                  } else if (link.model === "HubSubDetail") {
                    element = (
                      <HubSubDetail
                        slug={link.slug}
                        token={token}
                        onsignup={onsignup}
                        onLoginChange={onLoginChange}
                        userdetail={userdetail}
                      />
                    );
                  } else if (link.model === "HubFinal") {
                    element = (
                      <HubFinal
                        slug={link.slug}
                        token={token}
                        onsignup={onsignup}
                        onLoginChange={onLoginChange}
                        userdetail={userdetail}
                      />
                    );
                  }

                  return (
                    <Route
                      key={link.slug}
                      path={`/${link.slug}`}
                      element={element}
                    />
                  );
              })}



          {randomTest?.filter(item => item.up_sell || item.type == 'free_test')?.map((item) => {
              return (

                <Route
                  key={item.slug}
                  path={`/${item?.slug}`} 

                  element=

                        {item.up_sell ? (

                            <FreeTest onNavHide={onNavHide} token={token} free_test_slug={item?.slug} />

                        ) : (

                          <TestWrapper onNavHide={onNavHide} slug={item?.slug} token={token} free_test_slug={item?.slug} randomTest={randomTest} />
                          
                        )}

                />
              );
            })}

          
          <Route path="/blog" element={<Blog token={token} userdetail={userdetail} onLoginChange={onLoginChange} />} />

          <Route path="/blog-topic/:topicname?" element={<Blog token={token} userdetail={userdetail} onLoginChange={onLoginChange} />} />
      
          <Route path="/blog/:slug" element={<BlogDetail token={token} userdetail={userdetail} onLoginChange={onLoginChange} />} />

          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/userdashboard" element={<Userdashboard globaltest={globaltest} />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile onLoginChange={onLoginChange} ProfileChange={ProfileChange} globaltest={globaltest} />
              </ProtectedRoute>
            }
          />
          <Route path="/mob" element={<DashboardMobile globaltest={globaltest} />} />

          <Route
            path="/achievements"
            element={
              <ProtectedRoute>
                <Achievements token={token} onLoginChange={onLoginChange} globaltest={globaltest} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications Notification={Notification} token={token}  globaltest={globaltest} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-paid/:result"
            element={

              <AdminPage onLoginChange={onLoginChange} />

            }
          />


          <Route
            path="/subcriptions"
            element={
              <ProtectedRoute>
                <UserSubcription token={token} onLoginChange={onLoginChange} globaltest={globaltest} />
              </ProtectedRoute>
            }
          />


          <Route path="/dilemma/:slug" element={<Dilemma onNavHide={onNavHide} token={token} />} />
          
          <Route
            path="/dilemma/:slug"
            element={

              <TestProtectedRoute randomTest={randomTest} hasSubscription={hasSubscription} >

                <Dilemma onNavHide={onNavHide} token={token} />

               </TestProtectedRoute>
            }
          />

          <Route path="/test/free-starter-quiz" element={<TemplatePage randomTest={randomTest} menuLink={menuLink} onsignup={onsignup}  />} />

          <Route
            path="/test/:slug"
            element={

              <TestProtectedRoute randomTest={randomTest} free_test_slug={free_test_slug} hasSubscription={hasSubscription} >

                <TestWrapper onNavHide={onNavHide} token={token} free_test_slug={free_test_slug} randomTest={randomTest} />

              </TestProtectedRoute>
            }
          />

           {/* {randomTest?.filter(item => !item.up_sell)?.map((item) => {
              return (
                 <>
                  
                    <Route
                      key={item.slug}
                      path={`/${item?.slug}`} 

                      element={

                          <TestProtectedRoute slug={item.slug} randomTest={randomTest} hasSubscription={hasSubscription} >
                            
                            {item.dilemma ? (

                             <Dilemma slug={item.slug} onNavHide={onNavHide} token={token} />

                            ):(

                              <Test slug={item.slug} onNavHide={onNavHide} token={token}  />

                            )}

                          </TestProtectedRoute>
                        }

                    />
                  
                 </>
              );
            })} */}


          <Route path="/price-plan" element={
            <ProtectedRoute>

              <PricePlan token={token} userdetail={userdetail} onLoginChange={onLoginChange} globaltest={globaltest} />

            </ProtectedRoute>
          } />

          <Route path="/sub/:slug" element={<SubShow token={token} userdetail={userdetail} onLoginChange={onLoginChange} />} />

          <Route path="/testquestions" element={

                <ProtectedRoute>

                    <TestQuestions />

                </ProtectedRoute>
            
            } />
          
          <Route path="/pastresults/:slug" element={

              <ProtectedRoute>

                  <PastResults free_test_slug={free_test_slug} userdetail={userdetail} onLoginChange={onLoginChange}  />
              
              </ProtectedRoute>
              } 
            />

            <Route path="/dilemma-past-results/:slug" element={

              <ProtectedRoute>

                  <DilemmaPasts free_test_slug={free_test_slug} userdetail={userdetail} onLoginChange={onLoginChange}  />
              
              </ProtectedRoute>
              } 
            />

          <Route path="/past-attempts" element={
              <ProtectedRoute>

                    <PastAttempts globaltest={globaltest} />

              </ProtectedRoute>
            } />

          <Route path="/zoom-meetings" element={
            
              <ProtectedRoute>
                <ZoomMetting globaltest={globaltest} />
              </ProtectedRoute>

            } />

          <Route path="/view-attempt/:attemptId" element={<ViewAttempt globaltest={globaltest} />} />

          <Route path="/darkpersonality" element={<DarkPersonality />} />

          {/* <Route
            path="/64archetypes/:slug"
            element={<ArchetypeDetailPage onsignup={onsignup} onLoginChange={onLoginChange} free_test_slug={free_test_slug} userdetail={userdetail} token={token} />}
          /> */}

           <Route
            path="/admin/:slug/:test_slug"
            element={

              <FinalPage onLoginChange={onLoginChange} admin={true} />

            }
          />

          {/* <Route
            path="/admin/:slug/:test_slug"
            element={

              <ResultAll onLoginChange={onLoginChange} admin={true} />

            }
          /> */}

          <Route
            path="/result/:slug/:test_slug"
            element={<ResultAll onLoginChange={onLoginChange} userdetail={userdetail} globaltest={globaltest} />}
          />
          
          <Route path="/dilemma-result/:slug" element={<DilemaResultBeforePayment token={token}  onLoginChange={onLoginChange} admin={false} free={false}  />}  />

          <Route path="/admin/dilemma-full/:slug" element={<DilemaResultBeforePayment token={token}  onLoginChange={onLoginChange} admin={true} free={false}  />}  />

          <Route path="/admin/dilemma-free/:slug" element={<DilemaResultBeforePayment token={token}  onLoginChange={onLoginChange} admin={false} free={true}  />}  />

          <Route path="/admin/dilemma-result/:slug" element={<DilemaQuizResult token={token}  admin={true} />}  />

          <Route path="/result/dilemma/:slug" element={<DilemaQuizResult  admin={false} />} paid={false} />

          <Route path="/admin/dilemma/:slug" element={<DilemaQuizResult admin={true} paid={true} />} />
        
          <Route
            path="/admin-test/:slug/:test_slug/"
            element={<DarkResult onLoginChange={onLoginChange} globaltest={globaltest} admin={true} />}
          />

          <Route
            path="/result/user/:slug/:test_slug"
            element={
              
              <ProtectedRoute>
              <DarkResult onLoginChange={onLoginChange} globaltest={globaltest} userdetail={userdetail} admin={false} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dilemma/user/:slug"
            element={
              
              <ProtectedRoute>
              <DilemmaNoTest onLoginChange={onLoginChange} globaltest={globaltest} userdetail={userdetail} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-results/:slug/:test_slug"
            element={<EmailResults onLoginChange={onLoginChange} />}
          />
          <Route
            path="/email/:slug/:test_slug"
            element={<DarkEmailResults onLoginChange={onLoginChange} globaltest={globaltest} />}
          />

          <Route
            path="/final/:slug/:test_slug"
            element={
              <ProtectedRoute>
                <FinalPage onLoginChange={onLoginChange} globaltest={globaltest}  admin={false} />
              </ProtectedRoute>
            }
          />

          <Route path="/deep" element={

              <DeepProtectedRoute  hasSubscription={hasSubscription} >

                  <DeepDrive globaltest={globaltest} />

              </DeepProtectedRoute>
          } />

          <Route
            path="/cognitive32"
            element={
              <ProtectedRoute>
                <Questions32 onLoginChange={onLoginChange} globaltest={globaltest} userdetail={userdetail} />
              </ProtectedRoute>
            }
          />


          <Route
            path="/side"
            element={<SideModalOne onLoginChange={onLoginChange} />}
          />
          <Route path="/two" element={<SideModalTwo />} />
          <Route path="/three" element={<SideModalThree />} />
          <Route path="/four" element={<SideModalFour />} />

          {/* Schedule Meeting (Protected) */}
          <Route
            path="/personality-mapping-section"
            element={
              <ProtectedRoute>
                <ScheduleMeeting onLoginChange={onLoginChange} globaltest={globaltest} userdetail={userdetail}  />
              </ProtectedRoute>
            }
          />

           <Route
              path="/all-result-grapth"
            element={
              <ProtectedRoute>
                  <ArchetypeTimeline token={token}  userdetail={userdetail}  />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-result/:result/"
            element={<AdminResult onLoginChange={onLoginChange} />}
          />

          <Route
            path="/admin-test-paid/:result/"
            element={<AdminTest onLoginChange={onLoginChange} globaltest={globaltest} />}
          />



          <Route
            path="about-us"
            element={<About />}
          />

          <Route
            path="terms"
            element={<Terms onsignup={onsignup} />}
          />

          <Route
            path="ebook"
            element={
              
              <ProtectedRoute>
              <Ebook token={token} globaltest={globaltest} userdetail={userdetail} onLoginChange={onLoginChange} />
              </ProtectedRoute>
            }
          />

          <Route path="user-ebook-store" element= {

            <ProtectedRoute>

              <EbookList globaltest={globaltest} userdetail={userdetail} token={token} />
              
            </ProtectedRoute>
            
          } />

          <Route path='dashboard' element={

              <ProtectedRoute>
                
                 <NewDashboard token={token} userdetail={userdetail} globaltest={globaltest} onLoginChange={onLoginChange} free_test_slug={free_test_slug} />

              </ProtectedRoute>
            } />

            <Route path="personality-quizzes" element={<QuizHub token={token} onsignup={onsignup} onLoginChange={onLoginChange} userdetail={userdetail} />} />

            <Route path="ebook/:slug" element={<AdaptorSinglePage token={token} onsignup={onsignup} /> } />

            <Route path="ebook-store" element={<AdaptorComponent /> } />

            <Route path="info-contact" element={<InfoContact /> } />

            <Route path="/404" element={<NoPage onsignup={onsignup} />} />

            <Route path="hub/:slug" element={<Hub />} />

            <Route path="/:slug" element={<TemplatePage HubTemplateSlugs={HubTemplateSlugs} randomTest={randomTest} menuLink={menuLink} onsignup={onsignup} />} />
             
        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default AllRoutes;
